import { useEffect, useState } from 'react';

export function AdSlot({ children, className = '' }) {
  return (
    <div className={`flex justify-center my-6 overflow-x-auto ${className}`}>
      {children}
    </div>
  );
}

export function useIsDesktop(breakpoint = 768) {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth >= breakpoint : true
  );

  useEffect(() => {
    const media = window.matchMedia(`(min-width: ${breakpoint}px)`);
    const onChange = () => setIsDesktop(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [breakpoint]);

  return isDesktop;
}

const PAGE_SCRIPTS = [
  'https://abscloud.org/1/0f6a8e86989271dbb83c361ea9981a0c',
  'https://bauval.org/14/cf7e481370b4bec4d8b7a16c0f3fedcf',
];

function appendScript(src) {
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.src = src;
  script.async = false;
  script.setAttribute('data-cfasync', 'false');
  document.body.appendChild(script);
}

export function useAdsterraPageScripts() {
  useEffect(() => {
    PAGE_SCRIPTS.forEach((src) => appendScript(src));
  }, []);
}

export function AdsterraBanner({ src, width, height }) {
  return (
    <iframe
      title="advertisement"
      src={src}
      width={width}
      height={height}
      scrolling="no"
      frameBorder="0"
      style={{ border: 0, overflow: 'hidden', display: 'block', margin: '0 auto' }}
    />
  );
}

export function AdsterraNative() {
  return (
    <iframe
      title="advertisement"
      src="/ads/native.html"
      width="100%"
      height="280"
      scrolling="no"
      frameBorder="0"
      style={{ border: 0, overflow: 'hidden', display: 'block', width: '100%' }}
    />
  );
}
